// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle--2TN4B"};